<template>
  <BrainGarden>
    <slot />
  </BrainGarden>
</template>
